import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PrimaryButton } from '../common/Buttons';
import GuaranteeImage from '../images/cta-person.png';
import './style.css';

function GuaranteeSection({ id }) {
  return (
    <section
      id={id || "guarantee"}
      className="guarantee-section"
    >
      <Container>
        <div className="guarantee-gradient-box">
          <img
            src={GuaranteeImage}
            alt="Guarantee Illustration"
            className="guarantee-img d-none d-md-block"
            draggable="false"
          />
          <Row className="align-items-center">
            <Col md={{ size: 7, offset: 5 }} xs="12">
              <div className="guarantee-textbox text-center text-md-left">
                <h2 className="guarantee-title">
                  Try risk-free. 30-day guarantee.
                </h2>
                <div className="guarantee-desc">
                  If you’re not satisfied with our hosting in the first month, we’ll refund your money. No excuses.
                </div>
                <PrimaryButton href="#plans">
                  ✅ Explore Plans Now
                </PrimaryButton>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default GuaranteeSection;
